Vue.component('vq-repeater', {
  delimiters: ['[[', ']]'],
  inject: ['$validator'],
  props: {
    sectionFields: Object,
    repeaterFields: Array,
    repeat: Number,
    label: String,
    model: Array,
    name: String,
    classes: String,
    labelClasses: {
      type: String,
      default: 'col-md-5'
    },
    fieldClasses: {
      type: String,
      default: 'col-md-7'
    },
    nextFieldsOptionals: {
      type: Boolean,
      default: false
    },
    fieldsOptionals: {
      type: Array,
      default: () => []
    },
    startIndex: {
      type: Number,
      default: 1
    }
  },
  computed: {
    sync_model: {
      get() {
        return this.model
      },
      set(val) {
        this.$emit('update:model', val)
      }
    },
  },
  created() {

    // console.log('repeater', this.model)
    let rows = [];
    for (var i = 0; i <= this.repeat - 1; i++) {
      let row = {};
      // console.log(key+'_'+i);
      if (this.model[i] !== void 0) {
        row = this.model[i]
      } else {
        this.repeaterFields.forEach((key) => {
          row[key] = {}
        });
      }
      rows.push(row)
    }
    this.sync_model = rows;
    // console.log(rows);

  },
  template: `<div class="row row-small">
	<div v-for="(row, index) in model" :key="index" :class="classes ? classes : 'col-form-large'">
		<h3 class="c-primary fw-medium fs-18 pt-30 pb-25" v-if="label">[[label]] [[index + startIndex + 1]]</h3>
		<div v-for="fieldKey in repeaterFields" :key="fieldKey" class="form-group row row-small items-center">
			<div class="col-12" v-if="sectionFields[fieldKey].description">
				<p class="label pb-5 pb-n-md">[[sectionFields[fieldKey].description]]</p>
			</div>
			<div v-if="sectionFields[fieldKey].label && !sectionFields[fieldKey].labelTop" :class="labelClasses">
				<label class="label pb-5"
					:for="fieldKey + '_' + name + '_' + index">[[sectionFields[fieldKey].label]]</label>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'input'" :class="fieldClasses">
				<vq-input :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses" :model.sync="row[fieldKey]"
					:type="sectionFields[fieldKey].type"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label"
					:read-only="sectionFields[fieldKey].readOnly">
				</vq-input>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'datepicker'" :class="fieldClasses">
				<vq-datepicker :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses" :model.sync="row[fieldKey]"
					:type="sectionFields[fieldKey].type"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label"
					:read-only="sectionFields[fieldKey].readOnly">
				</vq-datepicker>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'radio'" :class="fieldClasses">
				<vq-radio :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses" :model.sync="row[fieldKey]"
					:options="sectionFields[fieldKey].options"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label">
				</vq-radio>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'checkbox'" :class="fieldClasses">
				<vq-checkbox :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses" :model.sync="row[fieldKey]"
					:option="sectionFields[fieldKey].option"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label">
				</vq-checkbox>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'select'" :class="fieldClasses">
				<vq-select :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses"
					:default-option="sectionFields[fieldKey].default" :options="sectionFields[fieldKey].options"
					:model.sync="row[fieldKey]"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label"
					:read-only="sectionFields[fieldKey].readOnly">
				</vq-select>
			</div>
			<div v-if="sectionFields[fieldKey].component == 'textarea'" :class="fieldClasses">
				<vq-textarea classes="is-medium" :name="fieldKey + '_' + name + '_' + index"
					:label="sectionFields[fieldKey].labelTop ? sectionFields[fieldKey].label : ''"
					:label-classes="sectionFields[fieldKey].labelClasses" :model.sync="row[fieldKey]"
					:optional="(fieldsOptionals.length && fieldsOptionals.includes(fieldKey)) || (index > 0 && nextFieldsOptionals) ? true : sectionFields[fieldKey].optional"
					:validate="sectionFields[fieldKey].validate" :validate-name="sectionFields[fieldKey].validateName ? sectionFields[fieldKey].validateName : sectionFields[fieldKey].label">
				</vq-textarea>
			</div>
		</div>
	</div>
</div>`
})